// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mi-perfil{ gap: 100px; }

.mi-perfil .caja-verde{ width: 450px; }

.mi-perfil h1{ font-size: 20px; }
.mi-perfil h2{ font-size: 18px; }

.mi-perfil p{ margin-bottom: 0px; }

.mi-perfil .linea{ gap: 50px; }
.mi-perfil .campo{ width: 100%; }
.mi-perfil input{ margin-right: -25px; }

.mi-perfil .cambiar-contrasena{
    width: fit-content;
    margin-left: auto;
    margin-top: 25px;
}

.mi-perfil .activar{ margin-top: 50px; }
.mi-perfil .activar h3{ margin-bottom: 7.5px; }
`, "",{"version":3,"sources":["webpack://./src/pages/user/css/Perfil.css"],"names":[],"mappings":"AAAA,YAAY,UAAU,EAAE;;AAExB,wBAAwB,YAAY,EAAE;;AAEtC,eAAe,eAAe,EAAE;AAChC,eAAe,eAAe,EAAE;;AAEhC,cAAc,kBAAkB,EAAE;;AAElC,mBAAmB,SAAS,EAAE;AAC9B,mBAAmB,WAAW,EAAE;AAChC,kBAAkB,mBAAmB,EAAE;;AAEvC;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,qBAAqB,gBAAgB,EAAE;AACvC,wBAAwB,oBAAoB,EAAE","sourcesContent":[".mi-perfil{ gap: 100px; }\n\n.mi-perfil .caja-verde{ width: 450px; }\n\n.mi-perfil h1{ font-size: 20px; }\n.mi-perfil h2{ font-size: 18px; }\n\n.mi-perfil p{ margin-bottom: 0px; }\n\n.mi-perfil .linea{ gap: 50px; }\n.mi-perfil .campo{ width: 100%; }\n.mi-perfil input{ margin-right: -25px; }\n\n.mi-perfil .cambiar-contrasena{\n    width: fit-content;\n    margin-left: auto;\n    margin-top: 25px;\n}\n\n.mi-perfil .activar{ margin-top: 50px; }\n.mi-perfil .activar h3{ margin-bottom: 7.5px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
